export const queryKeys = {
  reports: (companyId: string | number | undefined) => ["Reports", companyId],
  files: (companyId: string | number, deviationId?: number | string) => [
    "Files",
    String(companyId),
    String(deviationId) || "all",
  ],
  file: {
    all: () => ["Files"],
  },
  writeBlob: ["WriteBlob"],
  blobUrl: ["BlobUrl"],
  assignment: {
    all: () => ["Assignment"],
    byId: (companyId: string | number, id: string | number) => [
      "Assignment",
      companyId,
      id,
    ],
    byInspectionId: (
      companyId: string | number,
      variationId: string | number
    ) => ["Assignment", companyId, variationId],
    byUserId: (companyId: string | number, userId: string | number) => [
      "Assignment",
      companyId,
      userId,
    ],
    byGroupId: (companyId: string | number, groupId: string | number) => [
      "Assignment",
      companyId,
      groupId,
    ],
  },
  listFiles: (companyId) => [`ListFiles`, companyId],
  searchParams: (key, value) => ["SearchParams", key, value],
  users: (companyId?) => ["Users", companyId],
  userById: (companyId: string | number, id: string | number) => [
    "Users",
    companyId,
    id,
  ],
  usersByCompanyId: (companyId: string | number) => ["Users", companyId],
  listBlobs: (companyId) => [`ListBlobs`, companyId],
  getSasToken: (companyId) => [`SasToken`, companyId],
  featuresByCompanyId: (companyId) => [`Features`, companyId],
  variationsAll: () => ["Variation"],
  variations: (companyId) => [`Variation`, "company", companyId],
  selectedVariation: (id: string) => ["Variation", id],
  companies: "Companies",
  image: (variationId, filename) => [`ImageName-${variationId}`, `${filename}`],
  imageslist: (id: number) => ["ImagesList", id],
  myUser: () => ["MyUser"],
  getCompany: (companyId) => ["Company", companyId],
  thumbnail: (variationId) => ["Thumbnail", variationId],
  deviationTypes: () => ["deviationTypes"],
  exitCategories: () => ["exitCategories"],
  status: () => ["status"],
  claimType: () => ["claimType"],
  groups: (companyId?) => ["portalGroups", companyId],
  deleteImage: (filename) => ["DeleteImage", filename],
  groupsByCompanyId: (companyId: string | number) => [
    "GroupsByCompanyId",
    companyId,
  ],
  deviations: (companyId) => [`Deviations`, companyId],
  deviationsByInspectionId: (companyId, inspectionId) => [
    `Deviations`,
    companyId,
    inspectionId,
  ],
};
